/**
 * <s-film> — Replays the home brand film.
 *
 * Required child markup:
 *   [data-film-stage]   — Element whose CSS animations make up the film; it is swapped for a fresh clone to restart.
 *   [data-film-replay]  — Button inside the stage that restarts the film (handled by delegation, so clones keep working).
 */
class SFilm extends HTMLElement {
  connectedCallback() {
    this.addEventListener('click', this.#onClick);
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.#onClick);
  }

  #onClick = (event) => {
    if (!event.target.closest('[data-film-replay]')) return;
    const stage = this.querySelector('[data-film-stage]');
    if (!stage) return;
    document.documentElement.classList.remove('ae-skip');
    stage.replaceWith(stage.cloneNode(true));
  };
}

if (!customElements.get('s-film')) {
  customElements.define('s-film', SFilm);
}
